<template>
    <basic-container>
        <avue-crud :option="option"
                   :table-loading="loading"
                   :data="data"
                   :page.sync="page"
                   :permission="permissionList"
                   :before-open="beforeOpen"
                   v-model="form"
                   ref="crud"
                   @row-update="rowUpdate"
                   @row-save="rowSave"
                   @row-del="rowDel"
                   @search-change="searchChange"
                   @search-reset="searchReset"
                   @selection-change="selectionChange"
                   @current-change="currentChange"
                   @size-change="sizeChange"
                   @refresh-change="onLoad"
                   @on-load="onLoad">

            <template slot="menuLeft" slot-scope="scope">
                <el-button type="primary"
                           size="small"
                           @click="applyFor">物资发放
                </el-button>
            </template>
            <template slot="menu" slot-scope="scope">
                <el-button type="text"
                           size="small"
                           v-if="permissionList.viewBtn"
                           icon="el-icon-view"
                           @click="openViewDialog(scope.row,permissionList.auditBtn)">查看
                </el-button>


                <el-button type="text"
                           size="small"
                             v-if="scope.row.distributeStatus==1"
                           icon="el-icon-edit"
                           @click="openEditDialog(scope.row)">编辑

                </el-button>
            </template>
            <template slot="projectIdSearch">
                 <el-select v-model="searchForm.projectId" placeholder="请选择" @change="$forceUpdate()">
                    <el-option
                        v-for="item in projectList"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>
            <template slot="deptIdSearch">
                <el-select v-model="searchForm.deptId" placeholder="请选择" @change="$forceUpdate()">
                    <el-option
                        v-for="item in deptList"
                        :key="item.id"
                        :label="item.fullName"
                        :value="item.id">
                        </el-option>
                </el-select>
            </template>



        </avue-crud>
        <recipientsFrom ref="recipientsFrom" @onLoad="onLoad"></recipientsFrom>
    </basic-container>
</template>

<script>
    import {mapGetters} from "vuex";
    import recipientsFrom from "./recipients-from.vue";
    import {getProjectList1} from "@/api/crmedical/project/project";
    import {
        getProjectList,
        getWarehouseList,
        getDict,
        } from "@/api/crmedical/warehouse/index.js";

        import {treeDeptsByIds,getList,consumableList} from "@/api/crmedical/warehouse/outbound/grant.js"
    export default {
        components:{
            recipientsFrom
        },

        data() {
            return {
                form: {},
                valuetime:'',
                query: {},
                money:0,
                loading: false,
                page: {
                    pageSize: 10,
                    currentPage: 1,
                    total: 0
                },
                onloadFlag:false,//为了避免第一次请求必须在projecid赋值后进行
                selectionList: [],
                searchForm:{
                    projectId:'',
                    warehouseId:'',
                    people:''
                },
                projectList:[],//项目名称
                warehouseList:[],//仓库名称
                deptList:[],//科室列表
                statusList:[],//状态
                option: {
                    height: 'auto',
                    calcHeight: 30,
                    tip: false,
                    addBtn:false,
                    searchShow: true,
                    searchMenuSpan: 24,
                    border: true,
                    index: true,

                    emptyBtn:true,
                    viewBtn: false,
                    selection: false,
                    stripe:true,
                    dialogClickModal: false,
                    column: [

                                {
                                    label: "项目名称",
                                    prop: "projectId",
                                    dicUrl: '/api/v4ward/project/getProjectList',
                                    search: true,
                                    searchSpan:6,
                                    type:'select',
                                    searchslot:true,
                                    dataType: 'string',
                                    dicData:[],
                                    props:{
                                        label:'name',
                                        value:'id'
                                    },
                                    value:'',
                                    rules: [{
                                        required: true,
                                        message: "请选择项目",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "发放单号",
                                    prop: "distributeNo",

                                },
                                {
                                    label: "使用人",
                                    prop: "acceptUserNamePhone",

                                },
                                {
                                    label: "发放人",
                                    prop: "submitUserNamePhone",

                                },
                                {
                                    label: "发放时间",
                                    prop: "submitTime",

                                },
                                {
                                    label: "物品数量",
                                    prop: "distributeNum",

                                },

                                {
                                    label: "使用科室",
                                    prop: "deptId",
                                    search: true,
                                    hide:true,
                                    searchSpan:6,
                                    searchslot:true,
                                    type:'select',
                                    rules: [{
                                        required: true,
                                        message: "请选择科室",
                                        trigger: "change"
                                    }]
                                },




                                {
                                    label: "状态",
                                    prop: "distributeStatus",
                                    search: true,
                                    searchSpan:6,
                                    type:'select',
                                    dataType:'string',
                                    dicUrl:'/api/blade-system/dict/dictionary?code=warehouse_distribute_status',
                                    props:{
                                        label:'dictValue',
                                        value:'dictKey'
                                    },
                                    rules: [{
                                        required: true,
                                        message: "请选择状态",
                                        trigger: "change"
                                    }]
                                },
                                {
                                    label: "发放单号",
                                    searchSpan:6,
                                    prop: "distributeNo2",
                                    search: true,
                                    hide:true,
                                    maxlength: 21,
                                    showWordLimit: true,

                                },
                                              ]
                },
                data: [],
                userlist: [],
        value: [],
        list: [],
        loading: false,

      }

        },
          mounted() {
        this.list = this.states.map(item => {
            return { value: `value:${item}`, label: `label:${item}` };
        });
        },
        created() {
                this.fetchData();
                setTimeout(()=>{
                    window.onresize = ()=>{
                        this.$refs.crud.$refs.table.doLayout();
                    }
                })
                this.$nextTick(() => {
            setTimeout(()=>{
              this.$refs.crud.$children[1].$children[3].$el.addEventListener("click", ()=>{

                    if(this.option.height == this.bodyHeight - 390){
                      this.option.height = this.bodyHeight - 280
                    }else{
                      this.option.height = this.bodyHeight - 390;
                    }
                    this.$refs.crud.getTableHeight();
                });
              })

        });
            this.option.height = this.bodyHeight - 390;

        },
        computed: {
            ...mapGetters(["permission",'userInfo']),
            permissionList() {
                return {
                    addBtn: this.vaildData(this.permission.warehouserequisitionconsumable_add, false),
                    viewBtn: this.vaildData(this.permission.warehouserequisitionconsumable_view, true),
                    delBtn: this.vaildData(this.permission.warehouserequisitionconsumable_delete, false),
                    editBtn: this.vaildData(this.permission.warehouserequisitionconsumable_edit, false),
                    auditBtn: this.vaildData(this.permission.warehouserequisitionconsumable_audit, false),
                };
            },
            ids() {
                let ids = [];
                this.selectionList.forEach(ele => {
                    ids.push(ele.id);
                });
                return ids.join(",");
            }
        },

        methods: {
             // 根据当前登录人获取科室
                treeDeptsByIds(){
                        treeDeptsByIds().then(res=>{
                                this.deptList = res.data;
                                this.searchForm.deptId = this.deptList[0].id;
                                this.onloadFlag = true;
                                this.onLoad();
                        })
                },

            async fetchData() {
                this.pageLoading = true;

                try {
                    //projectList
                    const resProjectList = await getProjectList();
                    this.projectList = resProjectList.data;
                    this.searchForm.projectId = this.projectList[0]? this.projectList[0].id:'';
                    this.treeDeptsByIds();
                } catch (err) {
                    console.log("err==>", err);
                }
                this.pageLoading = false;
                },
            // 打开申请表单 新增
            applyFor(){
                let dicData = {
                    projectIdDictDataList:this.projectList,
                    userlist:this.userlist,

                }
                this.$refs.recipientsFrom.openDialog({type:'add',dicData:dicData});
            },
            // 打开编辑弹窗
            openEditDialog(row){
                console.log(row)
                let dicData = {

                    projectIdDictDataList:this.projectList,
                    userlist:this.userlist,

                }
                this.$refs.recipientsFrom.openDialog({type:'edit',dicData:dicData,data:row,});
            },
            // 打开查看弹窗
            openViewDialog(row,auditBtn){

                let dicData = {

                    projectIdDictDataList:this.projectList,
                    userlist:this.userlist,

                }
                this.$refs.recipientsFrom.openDialog({type:'view',dicData:dicData,data:row,auditBtn:auditBtn,});
            },

            // 申请人模糊搜索
             remoteMethod(query) {
                if (query !== '') {
                this.loading = true;
                setTimeout(() => {
                    this.loading = false;
                    this.options = this.list.filter(item => {
                    return item.label.toLowerCase()
                        .indexOf(query.toLowerCase()) > -1;
                    });
                }, 200);
                } else {
                this.options = [];
                }
            },
            rowSave(row, done, loading) {
                add(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowUpdate(row, index, done, loading) {
                update(row).then(() => {
                    this.onLoad();
                    this.$message.success('操作成功!');
                    done();
                }, error => {
                    window.console.log(error);
                    loading();
                });
            },
            rowDel(row) {
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: row.id});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                    });
            },
            handleDelete() {
                if (this.selectionList.length === 0) {
                    this.$message.warning("请选择至少一条数据");
                    return;
                }
                this.$confirm("确定将选择数据删除?", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning"
                })
                    .then(() => {
                        return remove({ids: this.ids});
                    })
                    .then(() => {
                        this.onLoad();
                        this.$message.success('操作成功!');
                        this.$refs.crud.toggleSelection();
                    });
            },

            cleanForm() {
                for(let key in this.form){
                    this.form[key] = null;
                }
            },
            searchReset() {
                this.searchForm.projectId = this.projectList[0]?this.projectList[0].id:'';
                this.searchForm.deptId = this.deptList[0]?this.deptList[0].id:'';
                // this.searchForm.requisitionUser = '';
                this.query.requisitionNo2 = '';
                this.query.requisitionUser = '';
                this.valuetime = ''


                this.query = {};
                this.$refs.crud.toggleSelection();
                this.onLoad();
            },
            searchChange(params, done) {
                this.query = params;
                this.page.currentPage = 1;
                this.onLoad();
                done();
            },
            selectionChange(list) {
                this.selectionList = list;
            },
            selectionClear() {
                this.selectionList = [];
                this.$refs.crud.toggleSelection();
            },
            currentChange(currentPage) {
                this.page.currentPage = currentPage;
            },
            sizeChange(pageSize) {
                this.page.pageSize = pageSize;
            },
            onLoad(page) {
                if(!this.onloadFlag){
                    return;
                }
                page = page || this.page;
                this.query.projectId = this.searchForm.projectId || '';
                this.query.deptId =  this.searchForm.deptId || '';
                // this.query.requisitionUser = this.searchForm.requisitionUser || '';
                this.query.distributeNo = this.query.distributeNo2 || '';


                if(this.valuetime){
                    this.query.timeStart = this.dayjs(this.valuetime[0]).format('YYYY-MM-DD HH:mm:ss');
                    this.query.timeEnd = this.dayjs(this.valuetime[1]).format('YYYY-MM-DD HH:mm:ss');
                }

                this.loading = true;
                console.log(this.query)
                getList(
                    Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
                ).then(({data}) => {
                    this.page.total = data.total;
                    data.records.forEach(ele=>{
                        if(ele.acceptUserPhone){
                            ele.acceptUserNamePhone = ele.acceptUserName +'('+ ele.acceptUserPhone +')'
                        }else{
                            ele.acceptUserNamePhone = ele.acceptUserName
                        }
                        if(ele.submitUserPhone){
                            ele.submitUserNamePhone = ele.submitUserName +'('+ ele.submitUserPhone +')'
                        }else{
                            ele.submitUserNamePhone = ele.submitUserName
                        }


                    })
                    this.data = data.records;
                    this.loading = false;
                    // this.selectionClear();
                });
            }
        }
    };
</script>
<style  scoped>


::v-deep .avue-form__menu--center{
    text-align: right;
  }
::v-deep   .avue-crud__search .el-form-item--small.el-form-item{
    width: 100%;
  }
</style>